export default "__VITE_ASSET__51190201__"